"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _H = _interopRequireDefault(require("../heading/H3"));
var _Paragraph = _interopRequireDefault(require("../misc/Paragraph"));
var _Statistic = _interopRequireDefault(require("./Statistic.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Statistic = function Statistic(_ref) {
  var count = _ref.count,
    label = _ref.label,
    color = _ref.color,
    labelColor = _ref.labelColor,
    size = _ref.size,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/_react["default"].createElement(_Statistic["default"], {
    color: color,
    labelColor: labelColor,
    size: size,
    "data-testid": dataTestId
  }, /*#__PURE__*/_react["default"].createElement(_H["default"], null, count), /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], null, label));
};
Statistic.defaultProps = {
  color: '#000',
  labelColor: '#4A4A4A',
  size: 'small',
  dataTestId: 'statistic'
};
Statistic.propTypes = {
  count: _propTypes["default"].number.isRequired,
  label: _propTypes["default"].string.isRequired,
  color: _propTypes["default"].string,
  labelColor: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['small', 'large', 'medium']),
  dataTestId: _propTypes["default"].string
};
Statistic.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Statistic",
  "props": {
    "color": {
      "defaultValue": {
        "value": "'#000'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "labelColor": {
      "defaultValue": {
        "value": "'#4A4A4A'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }]
      },
      "required": false
    },
    "dataTestId": {
      "defaultValue": {
        "value": "'statistic'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "count": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "label": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = Statistic;
exports["default"] = _default;